import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-all-zone',
  templateUrl: './all-zone.component.html',
  styleUrls: ['./all-zone.component.scss']
})
export class AllZoneComponent implements OnInit {

  constructor() { }

  ngOnInit(): void {
  }

}
